import { Divider, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router';
import { useAuthStore } from '../../stores/auth/auth.store';
import AppMenu from './AppMenu';
import type { SubmenuProps } from './submenu-props';

const UserMenu = (props: SubmenuProps) => {
  const navigate = useNavigate();
  const { logout, user } = useAuthStore((state) => state);

  const goTo = (route: string) => {
    navigate(route);
    props.onClose();
  };

  return (
    <AppMenu anchorEl={props.anchorElem} open={!!props.anchorElem} onClose={props.onClose}>
      <MenuItem onClick={() => goTo(`/usuarios/editar/${user?.id}?source=menu`)}>
        Editar mi usuario
      </MenuItem>
      <Divider />
      <MenuItem onClick={logout}>Cerrar sesión</MenuItem>
    </AppMenu>
  );
};

export default UserMenu;
